import createReducer from 'store/create-reducer';
import moment from 'moment';
import { colors } from 'utils/colors';
import { setAdditionalLanguages } from 'components/LanguageSelector/modules/actions';
import { loadingAction } from 'store/globalState/global';
import apiFetch from 'utils/apiFetch';
import {
  FETCH_INSTANCE, SET_AUTHENTICATED, SELECT_USER, CHANGE_OPEN_CHAT,
  SET_SPLASH_SCREEN, NOTIFICATION_TO_ROOM, NOTIFICATION,
} from './types';

const INITIAL_STATE = {
  actual_date: 0,
  date_diff: 0,
  code: false,
  color1: '',
  color2: '',
  color3: '',
  color4: '',
  color5: '',
  color6: '',
  color7: '',
  colors,
  lang: '',
  logo: '',
  name: '',
  elements_showing: '',
  main_element: '',
  phantom_user: '',
  state: '',
  use_policy: '',
  isAuthenticated: false,
  id: 0,
  poweredBy: '',
  selectedUser: 0,
  splashScreen: true,
  zoomMeeting: null,
  openChat: null,
};

export const fetchInstance = domain => (dispatch) => {
  dispatch(loadingAction(true));
  const params = {
    domain,
  };
  apiFetch('GET', { endPoint: 'instance' }, params)
    .then((response) => {
      const instance = Object.assign({}, response);
      const actualTime = moment().unix();
      instance.date_diff = actualTime - instance.actual_date;
      dispatch({ type: FETCH_INSTANCE, instance });

      if (typeof instance.advanced_configuration !== 'undefined' && typeof instance.advanced_configuration.additional_language_files !== 'undefined') {
        dispatch(setAdditionalLanguages(instance.advanced_configuration.additional_language_files));
      }

      dispatch(loadingAction(false));
    });
};

export const setSplashScreen = show => (dispatch) => {
  dispatch({ type: SET_SPLASH_SCREEN, splashScreen: show });
};

export const viewUserProfile = selectedUser => (dispatch) => {
  dispatch({ type: SELECT_USER, selectedUser });
};

export const setIsAuthenticated = isAuthenticated => (dispatch) => {
  dispatch({ type: SET_AUTHENTICATED, isAuthenticated });
};

export const openChatModal = chatId => (dispatch) => {
  dispatch({ type: CHANGE_OPEN_CHAT, openChat: chatId });
};

const handleAppNodeNotifications = (state, notification) => {
  switch (notification.req_message) {
    case 'join_zoom_meeting':
      return {
        ...state,
        zoomMeeting: notification,
      };
    default:
      break;
  }

  return state;
};

const ACTION_HANDLERS = {
  [CHANGE_OPEN_CHAT]: (state, { openChat }) => ({
    ...state,
    openChat,
  }),
  [SELECT_USER]: (state, { selectedUser }) => ({
    ...state,
    selectedUser,
  }),
  [FETCH_INSTANCE]: (state, { instance }) => ({
    ...state,
    ...instance,
  }),
  [SET_AUTHENTICATED]: (state, { isAuthenticated }) => ({
    ...state,
    isAuthenticated,
  }),
  [SET_SPLASH_SCREEN]: (state, { splashScreen }) => ({
    ...state,
    splashScreen,
  }),
  [NOTIFICATION]: (state, action) => {
    return handleAppNodeNotifications(state, action.payload);
  },
  [NOTIFICATION_TO_ROOM]: (state, action) => {
    return handleAppNodeNotifications(state, action.payload);
  },
};

export default createReducer(INITIAL_STATE, ACTION_HANDLERS);



// WEBPACK FOOTER //
// ./src/modules/app/index.js